import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
import _imports_0 from '../../assets/arrow-right.png';
const _hoisted_1 = { class: "account-info" };
const _hoisted_2 = { class: "avatar-container" };
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
    key: 1,
    class: "badge"
};
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "account-details" };
const _hoisted_7 = { class: "provider-name" };
const _hoisted_8 = { class: "line-1" };
const _hoisted_9 = {
    key: 0,
    class: "line-2"
};
const _hoisted_10 = {
    key: 0,
    class: "balance-section"
};
const _hoisted_11 = { class: "label" };
const _hoisted_12 = { class: "value" };
const _hoisted_13 = { class: "label label-2" };
const _hoisted_14 = { class: "value" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountListItem',
    props: {
        providerName: {},
        line1: {},
        line2: {},
        value: {},
        avatarUrl: {},
        badgeUrl: { default: '' },
        label: { default: 'Balance' },
        label2: { default: '' },
        value2: { default: '' }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const imageError = ref(false);
        function handleClick() {
            emit('click');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "account-list-item",
                onClick: handleClick
            }, [
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        (_ctx.avatarUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: imageError.value ? require('@/assets/round1.png') : _ctx.avatarUrl,
                                alt: _ctx.providerName,
                                class: "avatar",
                                onError: _cache[0] || (_cache[0] = ($event) => (imageError.value = true))
                            }, null, 40, _hoisted_3))
                            : _createCommentVNode("", true),
                        (_ctx.badgeUrl)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                _createElementVNode("img", {
                                    src: _ctx.badgeUrl,
                                    alt: _ctx.providerName,
                                    class: "badge-image"
                                }, null, 8, _hoisted_5)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.providerName), 1),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.line1), 1),
                        (_ctx.line2)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.line2), 1))
                            : _createCommentVNode("", true)
                    ])
                ]),
                (_ctx.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.label), 1),
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.value), 1),
                        (_ctx.label2)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.label2), 1),
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.value2), 1)
                            ], 64))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "arrow-icon" }, [
                    _createElementVNode("img", {
                        class: "arrow",
                        src: _imports_0
                    })
                ], -1))
            ]));
        };
    }
});
